module.exports = __webpack_public_path__ + "static/media/appstore.2928664f.svg";